import { RootState } from "../types";


export const adminListSelector = (state: RootState) => state.admin.langTranslate;
export const isSuperAdmin = (state: RootState) => state.admin.isSuperAdmin;
export const isSuperAdminByRoleId = (state: RootState) => state.user.admin.roleId === -1;
